export const GENERAL_OPTIONS = [
    {
        name: "Working at heights",
        price: 1.2
    },
    {
        name: "Working over water",
        price: 2.0
    },
    {
        name: "Hoisting/Rigging",
        price: 2.5
    },
    {
        name: "Excavating/Trenching",
        price: 3.0
    },
    {
        name: "Work area access",
        price: 3.5
    },
    {
        name: "Manual lifting",
        price: 3.0
    },
    {
        name: "Reversing vehicles",
        price: 2.0
    },
    {
        name: "Noise",
        price: 2.0
    },
    {
        name: "Power Tools",
        price: 2.0
    },
    {
        name: "Traffic",
        price: 2.0
    },
    {
        name: "Poor Housekeeping",
        price: 2.0
    },
    {
        name: "Pinch points",
        price: 2.0
    },
    {
        name: "Hot Work",
        price: 2.0
    },
    {
        name: "Ladders",
        price: 2.0
    },
    {
        name: "Scaffolds",
        price: 2.0
    },
    {
        name: "Buried Utilities",
        price: 2.0
    },
    {
        name: "Overhead Wires",
        price: 2.0
    }
];